"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadyScene = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const ReadyLayer_1 = require("../Layers/ReadyLayer");
const GameScene_1 = require("./GameScene");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const GameConfig_1 = require("../Core/GameConfig");
const SceneSwitcher_1 = require("./SceneSwitcher");
let ReadyScene = class ReadyScene extends pixi_js_1.Container {
    constructor(ioc, swicher, events, config) {
        super();
        const layer = ioc.resolve(ReadyLayer_1.ReadyLayer);
        layer.start = (auto) => {
            if (auto)
                config.autoplay = true;
            else
                config.autoplay = false;
            const game = ioc.resolve(GameScene_1.GameScene);
            swicher.switch(this, game).outEnd.add(remove => {
                this.destroy({ children: true });
                return remove();
            });
        };
        this.addChild(layer);
    }
};
ReadyScene = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [inversify_1.Container, SceneSwitcher_1.SceneSwitcher, SymbolClasses_1.GlobalEvents, GameConfig_1.GameConfig])
], ReadyScene);
exports.ReadyScene = ReadyScene;
//# sourceMappingURL=ReadyScene.js.map